import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedLocation: null,
};

const locationDropdownSlice = createSlice({
    name: 'locationDropdown',
    initialState,
    reducers: {
        // Reset the state
        resetLocationDropdown: (state) => {
            state.selectedLocation = null;
        },
        
        // Set selected location
        setDropdownSelectedLocation: (state, action) => {
            state.selectedLocation = action.payload;
        },
    },
});

// Export actions
export const { 
    resetLocationDropdown, 
    setDropdownSelectedLocation,
} = locationDropdownSlice.actions;

// Export reducer
export default locationDropdownSlice.reducer;

// Selectors
export const selectDropdownSelectedLocation = (state) => state.locationDropdown.selectedLocation;
